<template>
  <a-modal v-model="visible" :title="$t('设置密码')" :width="1000">
    <div slot="footer">
      <a-button @click="visible = false">{{ $t('取消') }}</a-button>
      <a-button :loading="loading" type="primary" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
      <a-row>
        <a-col :span="24">
          <a-form-model-item :label="$t('密码')" prop="password">
            <a-input-password v-model="form.password" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('确认密码')" prop="passwordVerify">
            <a-input-password v-model="form.passwordVerify" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import { savePassword } from '@/api/user/user'
import { getAppListForCurrentUser } from '@/api/app/app'
import md5 from 'js-md5'

export default {
  data() {
    return {
      visible: false,
      form: {},
      loading: false,
      appIdOptions: [],
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.user
    },
    rules() {
      const { verifyPassword } = this
      const result = {
        password: [{ required: true, message: this.$t('请输入') }],
        passwordVerify: [{ required: true, message: this.$t('请输入') }, { validator: verifyPassword, message: this.$t('密码不一致') }],
      }
      return result
    }
  },
  created() {
    this.loadOptions()
  },
  methods: {
    loadOptions() {
      getAppListForCurrentUser().then(res => {
        if (res.code === 0) {
          this.appIdOptions = res.data.map(e => ({
            label: e.name,
            value: e.id
          }))
        }
      })
    },
    show(data) {
      this.form = { ...data }
      this.visible = true
    },
    verifyPassword(r, v, c) {
      if (v == this.form.password) {
        c()
        return
      }
      c(this.$t('密码不一致'))
    },
    handleCommit() {
      this.$refs.form.validate((success) => {
        if (!success) {
          return
        }
        this.loading = true
        const commitData = {
          userId: this.form.id,
          password: md5(this.form.password)
        }
        savePassword(commitData).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('保存成功'))
            this.$emit('ok', this.form)
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).catch(err => {
          this.$message.error(this.$t('保存失败'))
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>